// extracted by mini-css-extract-plugin
module.exports = {"cartMenuIcon":"styles_cartMenuIcon__UtM1p"};